import { useEffect, useState } from 'react';
import { listSharedNotesForPlayer, type SharedNote } from '../lib/playerFeedback';
import './playerFeedback.css';

/**
 * Coach feedback shared with this player (session_player_notes, 00089).
 * Renders nothing when there are none — which also covers the pre-migration
 * state (the query returns [] on error).
 */
export function CoachFeedbackList({ playerId }: { playerId: string }) {
  const [notes, setNotes] = useState<SharedNote[]>([]);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const rows = await listSharedNotesForPlayer(playerId);
      if (!cancelled) setNotes(rows);
    })();
    return () => { cancelled = true; };
  }, [playerId]);

  if (notes.length === 0) return null;

  return (
    <section className="coach-feedback">
      <div className="page-section-label">Coach feedback</div>
      <ul className="coach-feedback__list">
        {notes.map((n) => (
          <li key={n.id} className="coach-feedback__item">
            <p>{n.note}</p>
            <span className="coach-feedback__date">{new Date(n.created_at).toLocaleDateString()}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
